import { type ExtractPropTypes, computed } from 'vue';

import { withFluidProps, useFluidProps } from '../../composables/props/fluid';
import { defaults } from '../defaults';
import { withColorProps, useColorProps, storiesColorArgs } from '../props/colors';
import { storiesDisabledArgs, withDisabledProps } from '../props/disabled';

export const withTooltipProps = {
  ...withDisabledProps,
  ...withColorProps(defaults.tooltip.color),
  ...withFluidProps(defaults.tooltip.fluid),

  /**
   * Treść w tooltipie
   */
  text: { type: String },

  /**
   * Klasa dla tooltipa
   */
  tooltipClass: { type: String },

  /**
   * Opóźnienie po którym pojawia się tooltip (w sekundach)
   */
  delay: { type: Number, default: defaults.tooltip.delay }
};

export function useTooltipProps(prefix: string, props: ExtractPropTypes<typeof withTooltipProps>) {
  const colorClasses = useColorProps(prefix, props);
  const fluidClasses = useFluidProps('w-tooltip-target', props);

  /** Wyliczone klasy tooltipa */
  const componentClasses = computed(() => {
    return [colorClasses.value, fluidClasses.value, props.tooltipClass];
  });

  /** Wyliczone klasy targetu */
  const targetClasses = computed(() => {
    return [fluidClasses.value];
  });

  return {
    componentClasses,
    targetClasses
  };
}

/**
 * Konfiguracja dla storybooka
 */
export const storiesTooltipArgs = {
  args: {
    text: 'Tooltip',
    tooltipClass: '',
    delay: defaults.tooltip.delay,

    ...storiesColorArgs.args,
    ...storiesDisabledArgs.args
  },

  argTypes: {
    text: {
      control: { type: 'text' }
    },
    tooltipClass: {
      control: { type: 'text' }
    },
    delay: {
      control: { type: 'number' }
    },

    ...storiesColorArgs.argTypes,
    ...storiesDisabledArgs.argTypes
  }
};
